<p-toast
  class="toast"
  position="top-right"
  [life]="config.life_time"
>
  <ng-template
    #message
    let-message
  >
    <div class="toast__content">
      <svg
        class="toast__icon"
        [icon]="`toast-${message.severity}-circle`"
      />

      <div class="toast__message">
        {{ message.detail }}
      </div>
    </div>
  </ng-template>
</p-toast>
